import { render } from "./Snowboarding.vue?vue&type=template&id=13c05068&scoped=true&bindings={\"images\":\"data\"}"
import script from "./Snowboarding.vue?vue&type=script&lang=js"
export * from "./Snowboarding.vue?vue&type=script&lang=js"

import "./Snowboarding.vue?vue&type=style&index=0&id=13c05068&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-13c05068"

export default script